import { useGoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { loginGoogle } from '../../api/AUTH/auth';
import { useState } from 'react';
import googleLogo from '../../assets/logos_officiels/google.svg';

function GoogleLoginButton() {
  const { fetchUser, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        // Fetch email from Google userinfo endpoint
        const userInfoRes = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = await userInfoRes.json();

        // Send access_token + email to backend
        await loginGoogle(tokenResponse.access_token, userInfo.email);

        await fetchUser();
        setIsLoggedIn(true);
        toast.success(`Bonjour ${userInfo.given_name ?? userInfo.email}, connexion réussie !`, {
          autoClose: 3000,
          hideProgressBar: true,
          pauseOnHover: true,
        });
        navigate('/home', { replace: true });
      } catch (error) {
        console.error('Erreur connexion Google :', error);
        toast.error(error.message || 'Erreur lors de la connexion Google');
      } finally {
        setLoading(false);
      }
    },
    onError: () => {
      toast.error('Erreur lors de la connexion Google', { autoClose: 3000, hideProgressBar: true });
    },
  });

  return (
    <button
      onClick={() => handleLogin()}
      disabled={loading}
      className="google-login-btn mx-auto"
      style={{ 
        width: '100%', 
        maxWidth: '280px',
        height: '44px', 
        fontSize: '15px', 
        fontWeight: '500',
        border: '1px solid #dadce0', 
        borderRadius: '6px',
        backgroundColor: '#fff',
        color: '#202124',
        padding: '10px 28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        cursor: loading ? 'not-allowed' : 'pointer',
        opacity: loading ? 0.6 : 1,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}
      onMouseOver={(e) => !loading && (e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.12)')}
      onMouseOut={(e) => !loading && (e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.08)')}
    >
      <img
        src={googleLogo}
        alt="Google logo"
        style={{ width: '20px', height: '20px' }}
      />
      {loading ? 'Connexion...' : 'Se connecter avec Google'}
    </button>
  );
}

function GoogleButton() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <GoogleLoginButton />
    </GoogleOAuthProvider>
  );
}

export default GoogleButton;
